<template>
  <div class="pagination">
    <div class="pagination__info">
      {{ grid.count }} {{ $t('common_content.of') }} {{ grid.total }}
    </div>
    <b-pagination class="pagination__content" size="md" :total-rows="grid.total" :per-page="searchPayload.limit"
                  v-model="page"
                  @input="changePaginateState"
    ></b-pagination>
  </div>
</template>
<script>
export default {
  name: 'WdPagination',
  props: {
    limit: {
      type: Number,
      default: () => 100
    },
    offset: {
      type: Number,
      default: () => 0
    },
    grid: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    const { limit, offset } = this
    return {
      searchPayload: {
        limit, offset
      },
      page: 1
    }
  },
  methods: {
    changePaginateState () {
      const searchObject = {
        limit: this.searchPayload.limit,
        offset: (this.page - 1) * this.searchPayload.limit
      }
      this.$emit('pageChanged', searchObject)
    }
  }
}
</script>
<style scoped lang="sass">
.pagination
  margin: 10px 0
  position: relative
  justify-content: center
  align-items: center
  &__info
    margin-right: 60px
    position: absolute
    left: 0
    top: 10px
    display: inline-block
</style>


// WEBPACK FOOTER //
// src/components/common/WdPagination.vue